// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"b797dbd0","423":"dc7a60ac","454":"fa0f5985","557":"bfa32707","708":"2bf84f41","759":"9eb78fd1"}[chunkId] + ".chunk.js";
};